import { Badge, styled } from "@mui/material";
import { STATUS, SURFACE } from "@/theme/tokens";

/** The header bell's count badge — one look for the staff bell (unseen notifications) and the admin bell (requests). */
export const BellBadge = styled(Badge)(() => ({
	"& .MuiBadge-badge": {
		right: -3,
		top: 3,
		border: `2px solid ${SURFACE}`,
		padding: "0 4px",
		backgroundColor: STATUS.ERROR.main,
		color: "white",
		fontWeight: "bold",
	},
}));

/** Counts above this show as "99+". */
export const BELL_BADGE_MAX = 99;
